var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination"},_vm._l((_vm.link),function(item,i){return _c('span',{key:i,class:{'is-active': item.active, 'is-disabled': !item.url },on:{"click":function($event){return _vm.callback(item)}}},[_vm._v(_vm._s(item.label))])}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92dca4da","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pagination.vue
// module id = EJd5
// module chunks = 25 28 29 31 32 33 34 41